import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, ChevronRight } from "lucide-react";
import { fetchProducts } from "../lib/api";
import { MenuItem } from "../components/MenuItem";
import { ProductModal } from "../components/ProductModal";

export default function Menu() {
    const [products, setProducts] = useState([]);
    const [active, setActive] = useState(null);

    useEffect(() => {
        fetchProducts().then(setProducts).catch(console.error);
    }, []);

    return (
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-14" data-testid="menu-page">
            <div className="text-center">
                <p className="text-xs uppercase tracking-[0.3em] text-[var(--sss-pink)] font-semibold">Sweet Selections</p>
                <h1 className="font-serif-display text-5xl md:text-6xl font-bold mt-3">Our Menu</h1>
                <Heart size={16} className="inline mt-3 text-[var(--sss-pink)]" fill="#FF2A7A" strokeWidth={0} />
                <p className="mt-4 max-w-xl mx-auto text-[var(--sss-text-muted)]">
                    Choose your favorites — every treat is handcrafted to order. Tap any item to customize size and quantity.
                </p>
            </div>

            <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {products.map((p) => (
                    <MenuItem key={p.id} product={p} onOrder={setActive} />
                ))}
            </div>

            <div className="mt-14 text-center">
                <p className="text-[var(--sss-text-muted)] text-sm">Looking for something special?</p>
                <Link to="/custom-orders" className="btn-outline-pink mt-3" data-testid="menu-to-custom">
                    Request a Custom Order <ChevronRight size={16} />
                </Link>
            </div>

            {active && <ProductModal product={active} onClose={() => setActive(null)} />}
        </div>
    );
}
